import { render, staticRenderFns } from "./tree-virtual-node.vue?vue&type=template&id=a36598b6"
import script from "./tree-virtual-node.vue?vue&type=script&lang=js"
export * from "./tree-virtual-node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports